<template>
  <el-dialog
    title="备注"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >

    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              label="备注信息"
      >

        <el-input type="textarea" placeholder="如房号"  style="width: 90%;" :rows="6" maxlength="40" @input = "descInput" v-model="form.remarks">

    </el-input>
        <span class="circle"></span><span class="text">{{remnant}}/40</span>
      </el-form-item>
      <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'payconfigureEditForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      accuseVisible2: true,
      loading: false,
      remnant: 0, // 输入数
      deposit_type: '',
      dialogVisible: false,
      form: {
        remarks: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },
    handleClick () {

    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    descInput () {
      var txtVal = this.form.remarks.length
      this.remnant = txtVal
    },
    dialogOpen () {
      // this.$refs.form.resetFields();
      this.form.remarks = this.agent.remarks
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.agent.id) {
            this.loading = true
            agentService.saveDepositgl({ ...this.form, id: this.agent.id })
              .then(data => {
                this.loading = false
                this.dialogVisible = false
                this.$emit('submit')
              })
          }
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
